import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useForm } from 'react-hook-form';

const ContactForm = ({ref}) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset
    } = useForm();

    const [connections, setConnections] = useState([]);
    const [nodes, setNodes] = useState([]);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    useEffect(() => {
        if (showSuccessPopup) {
            const timer = setTimeout(() => {
                setShowSuccessPopup(false);
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [showSuccessPopup]);

    // Generate interconnected cosmic neural network
    useEffect(() => {
        const generateCosmicNetwork = () => {
            const nodeCount = 40; // Increased node count
            const connectionCount = 60; // Increased connection count

            // Get viewport dimensions
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight * 2; // Cover more vertical space

            // Generate cosmic nodes (neurons) - DISTRIBUTED ACROSS ENTIRE VIEWPORT
            const nodeArray = [];
            for (let i = 0; i < nodeCount; i++) {
                nodeArray.push({
                    id: i,
                    x: Math.random() * viewportWidth,
                    y: Math.random() * viewportHeight,
                    size: Math.random() * 10 + 5, // Larger nodes
                    type: Math.floor(Math.random() * 3),
                    glowIntensity: Math.random() * 0.8 + 0.2,
                    pulseSpeed: Math.random() * 3 + 1,
                    delay: Math.random() * 3
                });
            }
            setNodes(nodeArray);

            // Generate connections between nodes - COVER ENTIRE AREA
            const connectionArray = [];
            for (let i = 0; i < connectionCount; i++) {
                const nodeA = nodeArray[Math.floor(Math.random() * nodeArray.length)];
                const nodeB = nodeArray[Math.floor(Math.random() * nodeArray.length)];

                // Sometimes create long-range connections to cover space
                const createLongRange = Math.random() > 0.7;
                let targetNodeB = nodeB;

                if (createLongRange) {
                    targetNodeB = {
                        ...nodeB,
                        x: Math.random() * viewportWidth,
                        y: Math.random() * viewportHeight
                    };
                }

                if (nodeA && targetNodeB && nodeA.id !== targetNodeB.id) {
                    connectionArray.push({
                        id: i,
                        from: { x: nodeA.x, y: nodeA.y },
                        to: { x: targetNodeB.x, y: targetNodeB.y },
                        thickness: Math.random() * 2 + 0.5, // Thicker connections
                        speed: Math.random() * 2 + 1,
                        pulseDelay: Math.random() * 2
                    });
                }
            }
            setConnections(connectionArray);
        };

        generateCosmicNetwork();

        // Handle window resize
        const handleResize = () => {
            generateCosmicNetwork();
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const onSubmit = async (data) => {
        console.log('Form data:', data);
        try {
            const res = await fetch("https://api.maxipitch.com/contact-us-angles", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "full_name": data.name,
                    "email": data.email,
                    "message": data.message
                }),
            });

            const json = await res.json();
            if (json.success) {
                setShowSuccessPopup(true);
                // Reset form
                reset();
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <div ref={ref} className="relative w-full py-16 overflow-hidden bg-black min-h-screen">
            {/* Cosmic Neural Network Background - COVERS ENTIRE AREA */}
            <div className="absolute inset-0 w-screen h-full">
                {/* Deep Space Gradient */}
                <div className="absolute inset-0 bg-gradient-to-b from-black via-purple-900/10 to-black"></div>

                {/* Large Nebula Clusters - COVER ALL SIDES */}
                {/* <motion.div
                    className="absolute top-1/4 left-1/4 w-[50rem] h-[50rem] bg-purple-600/10 rounded-full blur-3xl"
                    animate={{
                        scale: [1, 1.2, 1],
                        opacity: [0.06, 0.12, 0.06]
                    }}
                    transition={{
                        duration: 10,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                /> */}
                {/* <motion.div
                    className="absolute top-1/2 right-1/4 w-[45rem] h-[45rem] bg-cyan-600/10 rounded-full blur-3xl"
                    animate={{
                        scale: [1, 1.3, 1],
                        opacity: [0.05, 0.1, 0.05]
                    }}
                    transition={{
                        duration: 12,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 2
                    }}
                /> */}
                {/* <motion.div
                    className="absolute bottom-1/4 left-1/2 w-[55rem] h-[55rem] bg-indigo-600/10 rounded-full blur-3xl"
                    animate={{
                        scale: [1, 1.25, 1],
                        opacity: [0.04, 0.08, 0.04]
                    }}
                    transition={{
                        duration: 14,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 4
                    }}
                /> */}

                {/* Additional Nebula for Right Side */}
                {/* <motion.div
                    className="absolute top-1/3 right-1/3 w-[40rem] h-[40rem] bg-pink-600/8 rounded-full blur-3xl"
                    animate={{
                        scale: [1, 1.15, 1],
                        opacity: [0.03, 0.07, 0.03]
                    }}
                    transition={{
                        duration: 11,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 1
                    }}
                /> */}

                {/* Single SVG Container for all connections - COVERS ENTIRE AREA */}
                {/* <svg className="absolute inset-0 w-full h-full pointer-events-none">
                    {connections.map(conn => (
                        <motion.path
                            key={conn.id}
                            d={`M ${conn.from.x} ${conn.from.y} L ${conn.to.x} ${conn.to.y}`}
                            stroke="url(#neuralGradient)"
                            strokeWidth={conn.thickness}
                            fill="none"
                            strokeLinecap="round"
                            initial={{ pathLength: 0, opacity: 0 }}
                            animate={{
                                pathLength: [0, 1, 0],
                                opacity: [0, 0.4, 0]
                            }}
                            transition={{
                                duration: conn.speed * 3,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: conn.pulseDelay
                            }}
                        />
                    ))}
                </svg> */}

                {/* Cosmic Nodes (Neurons) - DISTRIBUTED EVERYWHERE */}
                {/* {nodes.map(node => {
                    const getNodeColor = () => {
                        switch (node.type) {
                            case 0: return "from-cyan-500 to-blue-500";
                            case 1: return "from-purple-500 to-pink-500";
                            case 2: return "from-indigo-500 to-cyan-500";
                            default: return "from-blue-500 to-cyan-500";
                        }
                    };

                    return (
                        <motion.div
                            key={node.id}
                            className={`absolute rounded-full bg-gradient-to-r ${getNodeColor()}`}
                            style={{
                                left: `${node.x}px`,
                                top: `${node.y}px`,
                                width: `${node.size}px`,
                                height: `${node.size}px`,
                                boxShadow: `0 0 ${node.size * 4}px ${node.size * 1.5}px currentColor`,
                                transform: 'translate(-50%, -50%)'
                            }}
                            animate={{
                                scale: [1, 1.4, 1],
                                opacity: [node.glowIntensity * 0.3, node.glowIntensity, node.glowIntensity * 0.3],
                                boxShadow: [
                                    `0 0 ${node.size * 4}px ${node.size * 1.5}px currentColor`,
                                    `0 0 ${node.size * 10}px ${node.size * 3}px currentColor`,
                                    `0 0 ${node.size * 4}px ${node.size * 1.5}px currentColor`
                                ]
                            }}
                            transition={{
                                duration: node.pulseSpeed,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: node.delay
                            }}
                        />
                    );
                })} */}

                {/* Data Pulses traveling along connections - EVERYWHERE */}
                {/* {connections.map((conn, index) => (
                    <motion.div
                        key={`pulse-${index}`}
                        className="absolute w-3 h-3 rounded-full bg-cyan-400"
                        style={{
                            filter: 'blur(1px)',
                            boxShadow: '0 0 15px 3px #00ffff',
                            transform: 'translate(-50%, -50%)'
                        }}
                        initial={{
                            x: conn.from.x,
                            y: conn.from.y,
                            scale: 0
                        }}
                        animate={{
                            x: [conn.from.x, conn.to.x],
                            y: [conn.from.y, conn.to.y],
                            scale: [0, 1, 0]
                        }}
                        transition={{
                            duration: 3 + Math.random() * 2,
                            repeat: Infinity,
                            ease: "linear",
                            delay: Math.random() * 4
                        }}
                    />
                ))} */}

                {/* Cosmic Grid - FULL COVERAGE */}
                {/* <div className="absolute inset-0 opacity-5"
                    style={{
                        backgroundImage: `
                            linear-gradient(to right, #4f46e5 1px, transparent 1px),
                            linear-gradient(to bottom, #4f46e5 1px, transparent 1px)
                        `,
                        backgroundSize: '80px 80px'
                    }}
                /> */}

                {/* Gradient definitions */}
                {/* <svg className="absolute w-0 h-0">
                    <defs>
                        <linearGradient id="neuralGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#00ffff" stopOpacity="0.6" />
                            <stop offset="50%" stopColor="#a855f7" stopOpacity="0.8" />
                            <stop offset="100%" stopColor="#00ffff" stopOpacity="0.6" />
                        </linearGradient>
                    </defs>
                </svg> */}
            </div>

            {/* Content - NO TEXT CHANGES */}
            <motion.div
                className="relative z-10"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
            >
                <div className="max-w-4xl mx-auto px-4">
                    {/* Section Title */}
                    <motion.div
                        className="text-center mb-12"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-white via-gray-300 to-white bg-clip-text text-transparent">
                            Contact Us
                        </h2>
                        <div className="w-24 h-1 bg-gradient-to-r from-cyan-500 to-blue-500 mx-auto mb-6"></div>
                        <p className="text-gray-300 text-lg max-w-2xl mx-auto">
                            Reach across the stars to learn more about The Angels Universe
                        </p>
                    </motion.div>

                    {/* Contact Form Container */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.5, duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <div className="relative">
                            {/* Form Glow Effect */}
                            <div className="absolute -inset-1 bg-gradient-to-r from-cyan-600/20 via-purple-800/20 to-pink-600/20 rounded-2xl blur-xl opacity-70"></div>

                            {/* Form Card */}
                            <div className="relative  backdrop-blur-sm border border-gray-800/50 rounded-2xl p-8 md:p-12 shadow-2xl">
                                <form onSubmit={handleSubmit(onSubmit)} className="max-w-2xl mx-auto">
                                    <div className="space-y-6">
                                        {/* Name Field */}
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2">
                                                Name *
                                            </label>
                                            <motion.input
                                                whileFocus={{ scale: 1.02 }}
                                                type="text"
                                                id="name"
                                                {...register("name", {
                                                    required: "Name is required",
                                                    minLength: {
                                                        value: 2,
                                                        message: "Name must be at least 2 characters"
                                                    }
                                                })}
                                                className="w-full px-4 py-3 bg-gray-800/80 backdrop-blur-sm border border-gray-700/50 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300"
                                                placeholder="Enter your full name"
                                            />
                                            {errors.name && (
                                                <motion.p
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: 1 }}
                                                    className="mt-1 text-red-300 text-sm"
                                                >
                                                    {errors.name.message}
                                                </motion.p>
                                            )}
                                        </div>

                                        {/* Email Field */}
                                        <div>
                                            <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                                                Email *
                                            </label>
                                            <motion.input
                                                whileFocus={{ scale: 1.02 }}
                                                type="email"
                                                id="email"
                                                {...register("email", {
                                                    required: "Email is required",
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                        message: "Invalid email address"
                                                    }
                                                })}
                                                className="w-full px-4 py-3 bg-gray-800/80 backdrop-blur-sm border border-gray-700/50 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300"
                                                placeholder="Enter your email address"
                                            />
                                            {errors.email && (
                                                <motion.p
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: 1 }}
                                                    className="mt-1 text-red-300 text-sm"
                                                >
                                                    {errors.email.message}
                                                </motion.p>
                                            )}
                                        </div>

                                        {/* Message Field */}
                                        <div>
                                            <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2">
                                                Message *
                                            </label>
                                            <motion.textarea
                                                whileFocus={{ scale: 1.02 }}
                                                id="message"
                                                rows={6}
                                                {...register("message", {
                                                    required: "Message is required",
                                                    minLength: {
                                                        value: 10,
                                                        message: "Message must be at least 10 characters"
                                                    }
                                                })}
                                                className="w-full px-4 py-3 bg-gray-800/80 backdrop-blur-sm border border-gray-700/50 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 resize-vertical"
                                                placeholder="Tell us about your interest in The Angels Universe..."
                                            />
                                            {errors.message && (
                                                <motion.p
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: 1 }}
                                                    className="mt-1 text-red-300 text-sm"
                                                >
                                                    {errors.message.message}
                                                </motion.p>
                                            )}
                                        </div>

                                        {/* Submit Button */}
                                        <motion.button
                                            type="submit"
                                            disabled={isSubmitting}
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                            className="w-full bg-gradient-to-r from-cyan-700 to-blue-600 hover:from-cyan-600 hover:to-blue-500 disabled:from-gray-600 disabled:to-gray-700 text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-2xl hover:shadow-cyan-500/25 disabled:shadow-none relative overflow-hidden group"
                                        >
                                            {/* Button Glow Effect */}
                                            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 group-hover:opacity-100 opacity-0 transition-opacity duration-300"></div>

                                            {/* Button Content */}
                                            <div className="relative z-10">
                                                {isSubmitting ? (
                                                    <div className="flex items-center justify-center">
                                                        <div className="w-5 h-5 border-t-2 border-white rounded-full animate-spin mr-2"></div>
                                                        Sending across the stars...
                                                    </div>
                                                ) : (
                                                    <>
                                                        Send Message
                                                        <svg className="w-5 h-5 ml-2 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                                                        </svg>
                                                    </>
                                                )}
                                            </div>
                                        </motion.button>
                                    </div>
                                </form>

                                {/* Form Footer */}
                                <motion.div
                                    className="mt-8 text-center text-gray-400 text-sm"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 1 }}
                                >
                                    <p>Your message will reach us across the cosmos</p>
                                    <p className="mt-1 text-xs text-gray-500">We typically respond within 24-48 hours</p>
                                </motion.div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </motion.div>
            <AnimatePresence>
                {showSuccessPopup && (
                    <motion.div
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        className="fixed top-4 right-4 z-50 max-w-sm"
                    >
                        <div className="bg-gradient-to-r from-green-900/90 to-emerald-900/90 backdrop-blur-lg border border-green-700/50 rounded-xl p-4 shadow-2xl">
                            <div className="flex items-start">
                                <div className="flex-shrink-0">
                                    <motion.div
                                        className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center"
                                        animate={{
                                            scale: [1, 1.2, 1],
                                            rotate: [0, 360]
                                        }}
                                        transition={{
                                            duration: 1,
                                            repeat: Infinity,
                                            repeatDelay: 2
                                        }}
                                    >
                                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                    </motion.div>
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-lg font-semibold text-white">Message Sent!</h3>
                                    <p className="mt-1 text-sm text-green-200">
                                        Thank you for contacting us. We'll get back to you soon.
                                    </p>
                                    <div className="mt-2">
                                        <div className="h-1 w-full bg-green-800/50 rounded-full overflow-hidden">
                                            <motion.div
                                                className="h-full bg-gradient-to-r from-green-500 to-emerald-400"
                                                initial={{ width: "100%" }}
                                                animate={{ width: "0%" }}
                                                transition={{ duration: 5, ease: "linear" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <button
                                    onClick={() => setShowSuccessPopup(false)}
                                    className="ml-4 text-green-300 hover:text-white transition-colors"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ContactForm;